const BanksTableColumns = [
    { id: "bank_name", labelAr: "البنك", labelEn: "Bank", sortable: true },
    { id: "company_name", labelAr: "اسم الشركة", labelEn: "Company Name", sortable: true },
    { id: "account_number", labelAr: "رقم الحساب", labelEn: "Account Number", sortable: true },
    { id: "currency", labelAr: "العملة", labelEn: "Currency", sortable: false },
    { id: "status", labelAr: "الحالة", labelEn: "Status", sortable: false },
];

export default BanksTableColumns;
